import React from 'react'

import Container from 'components/atoms/Container'
import Typography from 'components/atoms/Typography'
import { Row, Col } from 'components/qstrap'

import Relazsizes from 'relazsizes'

import config from 'config'

const { assets_url: assetsUrl } = config

const RIASECIntroduction = () => (
  <div className="aptitude-riasec">
    <div className="aptitude-riasec__bg">
      <Container>
        <Typography component="h2" variant="title" className="text-variant-title-sm m-b-md">Mengenal RIASEC</Typography>
        <Row>
          <Col md="5">
            <Typography component="p" variant="subbody" className="m-b-md">Mengetahui karier yang sesuai untukmu bukanlah hal mudah. Melalui tes psikologi RIASEC yang dikembangkan oleh Dr. John Holland ini, kamu akan mengetahui karier yang paling sesuai untukmu dengan melihat tingkat kecocokan pada beberapa kecenderungan minat, bakat, kepribadian, dan kemampuan kamu, yang dikembangkan melalui analisis dari kode-kode tertentu. Dengan mengetahui tipe-tipe kepribadian yang dominan, kamu dapat memperkirakan jenis karier dan lingkungan kerja seperti apa yang akan membuatmu nyaman dan optimal dalam bekerja. Selain itu, Quipper Campus juga akan membantu kamu untuk melihat tingkat kecocokan antara kepribadianmu dengan jurusan kuliah yang bisa kamu ambil. </Typography>
          </Col>
          <Col md="7">
            <Relazsizes
              dataSrc={`${assetsUrl}/assets/img/aptitude/riasec-x2.png`}
              alt="Mengenal RIASEC"
            />
          </Col>
        </Row>
      </Container>
    </div>
    <style jsx>
      {`
        .aptitude-riasec {
          margin-top: -120px;
          padding-bottom: 80px;
          @media screen and (max-width: 767px) {
            margin-top: -70px;
          }
          :global(img) {
            width: 100%;
            @media screen and (min-width: 768px) {
              padding: 0 40px 0 100px;
            }
          }
          :global(p) {
            color: #0c2846 !important;
          }
          &__bg {
            margin: auto;
            max-width: 1040px;
            padding: 50px 0;
            background-color: #fff;
            border-radius: 8px;
            z-index: 1;
            position: relative;
            @media screen and (max-width: 767px) {
              margin: auto 15px;
              padding: 15px 0;
              max-width: none;
            }
          }
        }
      `}
    </style>
  </div>
)

export default RIASECIntroduction
